module.exports = __webpack_public_path__ + "media/hp-win-profit.40e4e932.mp3";